import { OutlineFilter } from '@pixi/filter-outline';
// NOTE: Use OutlineFilter sparingly, it can be expensive to render, especially on mobile browsers (definitely seen as slow in iOS)
export function createOutlineFilter(color, thickness, quality = 0.1) {
    return new OutlineFilter(thickness, color, quality);
}
export const HOLE_CARDS_OUTLINE_FILTER = createOutlineFilter(0xffffff, 4, 0.5);
